import type { CourtHireBooking, CourtHireBookingStatus, CourtHireRate } from '../types/organization';

/** Unpaid checkout holds expire after this many minutes and release the court slot. */
export const COURT_HIRE_PENDING_HOLD_MINUTES = 5;

/** Rates shown on public guest court hire (excludes member-only rates). */
export function filterCourtHireRatesForPublicBooking(rates: CourtHireRate[]): CourtHireRate[] {
  return rates.filter((rate) => rate.isActive && !rate.membersOnly);
}

export type CourtHireBookerKind = 'member' | 'guest';

/** Member bookings set `memberId`; guest checkout leaves it null (guest fields are always populated). */
export function resolveCourtHireBookerKind(
  booking: Pick<CourtHireBooking, 'memberId'>
): CourtHireBookerKind {
  return booking.memberId ? 'member' : 'guest';
}

export function formatCourtHireBookerName(
  booking: Pick<CourtHireBooking, 'guestFirstName' | 'guestLastName' | 'guestEmail'>
): string {
  const name = [booking.guestFirstName, booking.guestLastName].filter(Boolean).join(' ').trim();
  return name || booking.guestEmail?.trim() || '—';
}

/** Unpaid checkout holds (`pending`) are not consumer reservations until payment confirms. */
export function isCourtHireBookingCalendarVisible(status: CourtHireBookingStatus): boolean {
  return status === 'confirmed';
}
